import { QuestionAnswer } from '../../../types';

export const QnASidebar = ({
  sidebarData,
}: {
  sidebarData: QuestionAnswer;
}): JSX.Element => {
  return (
    <div>
      <div className="text-font-200 text-s-20 mb-8 sm:text-s-14">
        Your Details From:{' '}
        <span className="text-[#243E65] font-bold">Manual Entry</span>
      </div>

      <ol className="ml-3">
        {Object.keys(sidebarData).map((questionId, index) => (
          <li
            key={questionId}
            className="steps-list border-l border-blue-350 pl-8 relative last:border-none  last:mb-3"
          >
            <div className="w-7 h-7 text-s-14 font-semibold rounded-full border border-blue-600 flex items-center justify-center bg-blue-600 absolute left-0 text-white -translate-x-2/4 sm:text-s-12">
              {index + 1}
            </div>
            <div className="pb-8 sm:pb-6">
              <div className="text-base text-font-200 font-medium sm:text-s-12">
                {sidebarData[questionId]?.question}
              </div>
              <div className="text-s-20 text-font-500 sm:text-s-12">
                {sidebarData[questionId]?.answer}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};
